import { styled } from 'styled-components';
import { IconSend } from '@tabler/icons-react';

export const StyledSendIcon = styled(IconSend)`
    height: 20px;
    width: 20px;
`;
